module.exports = __webpack_public_path__ + "static/p3-8247aced98a97936a203ca4148f66d4b.jpg";